import { usePermissions } from '../../hooks/usePermissions';
import { useUserProfile } from '../../hooks/useUserProfile';
import { SettingsSection } from './SettingsSection';
import { ProfileSection } from './ProfileSection';
import { CreatorIdentifiersSection } from './CreatorIdentifiersSection';
import { ImageProtectionSection } from './ImageProtectionSection';
import MarketingConsentSection from './MarketingConsentSection';
import { DeleteAccountSection } from './DeleteAccountSection';
import { LegalAgreementsSection } from '../LegalAgreementsSection';

export const AccountContent = () => {
  const { permissions } = usePermissions();
  const { profile, updateWatermarkEnabled } = useUserProfile();

  const isViewer = permissions?.role === 'viewer';
  const isDelegate = permissions?.role === 'delegate';

  return (
    <>
      <SettingsSection
        id="settings-profile"
        title="Profile"
        subtitle="Manage your name, display name, and email"
      >
        <ProfileSection />
      </SettingsSection>

      {!isViewer && !isDelegate && (
        <SettingsSection
          id="settings-identifiers"
          title="Creator Identifiers"
          subtitle="Link your Getty, ORCID, and ISNI profiles"
        >
          <CreatorIdentifiersSection />
        </SettingsSection>
      )}

      <SettingsSection
        id="settings-image-protection"
        title="Image Protection"
        subtitle="Control watermarking on your public images"
      >
        <ImageProtectionSection
          watermarkEnabled={profile?.watermarkEnabled ?? true}
          onWatermarkChange={updateWatermarkEnabled}
        />
      </SettingsSection>

      <SettingsSection
        id="settings-marketing"
        title="Marketing Preferences"
        subtitle="Manage your communication preferences"
      >
        <MarketingConsentSection />
      </SettingsSection>

      <SettingsSection
        id="settings-delete-account"
        title="Delete Account"
        subtitle="Permanently delete your account and all data"
      >
        <DeleteAccountSection />
      </SettingsSection>

      <SettingsSection
        id="settings-legal"
        title="Legal Agreements"
        subtitle="View terms of service and privacy policy"
      >
        <LegalAgreementsSection />
      </SettingsSection>
    </>
  );
};
